import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	FormGroup,
	Label,
	Input,
	Row,
	Col,
	Button,
	Modal,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import * as moment from "moment";
import {
	APPLICATION,
	DISTRICTS,
	CATEGORY,
	DEPARTMENT,
	SCHEME,
	CHANGE_SCHEME_STATUS,
	CAMPAIGN,
	BLOCKS,
	GRAM_PANCHAYAT
 } from '../../configs/urls'
import { getApi, postApi } from '../../services/api'
import { Link, useLocation } from "react-router-dom";

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import axios from 'axios'
import { APPLICATION_STATUS_LIST, DATE_FORMATS, PAGE_LIMIT, MESSAGES, ROLES_MAP, REPORT_DATE_TYPES } from '../../configs/constant'
import { getLoggedInUser } from '../../services/localstorage'
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import DatePicker from 'reactstrap-date-picker'

const Applications = (props) => {
	const { search } = useLocation();

	const campaignId = new URLSearchParams(search).get('campaign_id');
	const gpId = new URLSearchParams(search).get('gp_id');
	const selectedStatus = new URLSearchParams(search).get('status');
	const categoryId = new URLSearchParams(search).get('category_id');
	const schemeId = new URLSearchParams(search).get('scheme_id');
	const departmentId = new URLSearchParams(search).get('department_id');
	const districtId = new URLSearchParams(search).get('district_id');
	const blockId = new URLSearchParams(search).get('block_id');

	const [isRequesting, setIsRequestig] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isUpdateStatusModalOpen, setIsUpdateStatusModalOpen] = useState(false)
	const [canShowLoadMore, setCanShowLoadMore] = useState(false)

	const [applications, setApplications] = useState([])
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
	})
	const [districts, setDistricts] = useState([])
	const [blocks, setBlocks] = useState([])
	const [gramPanchayats, setGramPanchayats] = useState([])
	const [categories, setCategories] = useState([])
	const [schemes, setSchemes] = useState([])
	const [departments, setDepartments] = useState([])
	const [selectedApplication, setSelectedApplication] = useState({})
	const [applicationUpdateData, setApplicationUpdateData] = useState({})
	const loggedInUser = getLoggedInUser();
	const [isViewApplicationPaneOpen, setIsViewApplicationPaneOpen] = useState(false);
	const [selectedScheme, setSelectedScheme] = useState({});
	const [selectedDateType, setSelectedDateType] = useState(REPORT_DATE_TYPES.find((type) => type.id == 4))

	useEffect(() => {
		getAllData()
	}, [])

	const getAllData = () => {
		const params = filterParams;

		if(campaignId) {
			getApi(`${CAMPAIGN}/${campaignId}`).then(res => {
				setFilterParams({
					...filterParams,
					date: res.data.date
				});
				params.date = moment(res.data.date).format(DATE_FORMATS.DATE_SERVER_FORMAT)

				gpId ? getGramPanchayatsAndGetData(params) : getInitialDataAndSetApplications(params)
			})
		} else {
			gpId ? getGramPanchayatsAndGetData(params) : getInitialDataAndSetApplications(params)
		}
	}

	const getGramPanchayatsAndGetData = (params) => {
		getApi(`${GRAM_PANCHAYAT}/${gpId}`).then(res => {
			const block = getApi(BLOCKS, {district_id: res.data.district_id})
			const gp = getApi(GRAM_PANCHAYAT, {district_id: res.data.district_id, block_id: res.data.block_id})
			axios.all([block, gp]).then(allRes => {
				if(allRes[0] && allRes[0].data) {
					setBlocks(allRes[0].data)
				}
				if(allRes[1] && allRes[1].data) {
					setGramPanchayats(allRes[1].data)
				}
				setFilterParams({
					...filterParams,
					block_id: res.data.block_id,
					district_id: res.data.district_id,
					gram_panchayat_id: gpId
				});
		
				params.gram_panchayat_id = gpId
				params.block_id = res.data.block_id
				params.district_id = res.data.district_id
	
				getInitialDataAndSetApplications(params)
			})
		})
	}

	const getInitialDataAndSetApplications = (params) => {
		setIsRequestig(true)

		if(ROLES_MAP.department_officer == loggedInUser.role_id
			|| ROLES_MAP.field_officer == loggedInUser.role_id) {
			setFilterParams({
				...filterParams,
				department_id: loggedInUser.department_id
			});
			params.department_id = loggedInUser.department_id
		}

		if(ROLES_MAP.district_officer == loggedInUser.role_id
				|| ROLES_MAP.dpm == loggedInUser.role_id
				|| ROLES_MAP.field_officer == loggedInUser.role_id) {
			setFilterParams({
				...filterParams,
				district_id: loggedInUser.district_id
			});
			params.district_id = loggedInUser.district_id
		}

		if(categoryId) {
			setFilterParams({
				...filterParams,
				category_id: categoryId
			});
			params.category_id = categoryId
		}

		if(selectedStatus) {
			setFilterParams({
				...filterParams,
				status: selectedStatus
			});
			params.status = selectedStatus
		}

		if(schemeId) {
			setFilterParams({
				...filterParams,
				scheme_id: schemeId
			});
			params.scheme_id = schemeId
		}

		if(departmentId) {
			setFilterParams({
				...filterParams,
				department_id: departmentId
			});
			params.department_id = departmentId
		}

		if(districtId) {
			setFilterParams({
				...filterParams,
				district_id: districtId
			});
			params.district_id = districtId
		}

		if(blockId) {
			getApi(BLOCKS, { district_id: districtId }).then(res => {
				setBlocks(res.data)
			})
			setFilterParams({
				...filterParams,
				block_id: blockId
			});
			params.block_id = blockId
		}

		const district = getApi(DISTRICTS);
		
		const category = getApi(CATEGORY);
		const scheme = getApi(SCHEME);
		const department = getApi(DEPARTMENT);
		const application = getApi(APPLICATION, params);
		
		axios
			.all([district, category, scheme, department, application])
			.then((res) => {


				if (res[0] && res[0].data) {
					setDistricts(res[0].data)
				}

				if (res[1] && res[1].data) {
					setCategories(res[1].data)
				}

				if (res[2] && res[2].data) {
					setSchemes(res[2].data)
				}

				if (res[3] && res[3].data) {
					setDepartments(res[3].data)
				}

				if (res[4] && res[4].data) {
					setApplications(res[4].data)
					setCanShowLoadMore(res[4].data.length < res[4].meta.total)
				}
				
				if (res[5] && res[5].data) {
					setBlocks(res[5].data)
				}
				
				if (res[6] && res[6].data) {
					setGramPanchayats(res[6].data)
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequestig(false)
			})
	}

	const fetchApplication = (isLoadMore) => {
		const params = JSON.parse(JSON.stringify(filterParams))
		setIsLoading(true);

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		if(!params.from_date) {
			delete params.from_date
		} else {
			params.from_date = moment(params.from_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}

		if(!params.to_date) {
			delete params.to_date
		} else {
			params.to_date = moment(params.to_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}

		if(!params.date) {
			delete params.date
		} else {
			params.date = moment(params.date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}


		getApi(APPLICATION, params)
			.then((res) => {
				let applicationListData = isLoadMore ? [...applications, ...res.data] : res.data;
				setApplications(applicationListData || []);
				setCanShowLoadMore(applicationListData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				setIsLoading(false);
			})
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const searchApplication = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchApplication();
	}

	const resetFilter = () => {
		setFilterParams({
			from_date: null,
			to_date:  null,
			state_id: -1,
			status: -1,
			category_id: -1,
			department_id: -1,
			scheme_id: -1,
			mobile_no: '',
			district_id: -1,
			block_id: -1,
			gram_panchayat_id: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT,
		});

		setSelectedDateType(REPORT_DATE_TYPES[3])
	}

	const updateApplicationData = () => {
		const params = applicationUpdateData;
		if(params.status == 'reject' && !params.reject_reason) {
			Toaster.showError('Please add reject reason');
			return
		}

		setIsLoading(true);
		setIsUpdateStatusModalOpen(false);
		if(params.status != 'reject') {
			params.reject_reason = ''
		}
		params.id = selectedScheme.id
		postApi(`${APPLICATION}/${CHANGE_SCHEME_STATUS}`, params).then(res => {
			const items = applications;
			const idx = items.findIndex((application) => application.id == selectedApplication.id)
			const schemeIdx = items[idx].scheme_list.findIndex((scheme) => scheme.id == selectedScheme.id) 
			items[idx].scheme_list[schemeIdx].status = applicationUpdateData.status;
			items[idx].scheme_list[schemeIdx].reject_reason = applicationUpdateData.reject_reason;
			setSelectedApplication(items[idx])
			setApplications(items)
		}, (err) => {
			console.log(err);
		}).finally(() => {
			setIsLoading(false);
		})
	}

	const updateApplicationStatus = (scheme) => {
		setSelectedScheme(scheme)
		setApplicationUpdateData({
			...applicationUpdateData,
			status: scheme.status,
			reject_reason: (scheme.reject_reason || '')})
		setIsUpdateStatusModalOpen(true);
	}

	const loadMoreApplications = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchApplication(true)
	}

	const viewApplication = (application) => {
		setSelectedApplication(application)
		setIsViewApplicationPaneOpen(true)
	}

	const setSelectedDateTypeAndGetData = (e) => {
		const dateType = REPORT_DATE_TYPES.find(type => type.id == e.target.value)
		setSelectedDateType(dateType);
		
		if(e.target.value != 4) {
			setFilterParams({
				...filterParams,
				from_date: moment().subtract(dateType.month, 'month').toISOString(),
				to_date: moment().toISOString()
			})
		}
	}
	

	const getBlocks = (districtId) => {
		setIsLoading(true);

		getApi(BLOCKS, {district_id: districtId}).then(res => {
			setBlocks(res.data)
			setFilterParams({
				...filterParams,
				district_id: districtId,
				block_id: -1,
				gram_panchayat_id: -1
			})
		}, (err) => {
			console.log(err);
		}).finally(() => {
			setIsLoading(false);
		})
	}

	const getGps = (blockId) => {
		setIsLoading(true);
		
		getApi(GRAM_PANCHAYAT, {district_id: filterParams.district_id, block_id: blockId}).then(res => {
			setGramPanchayats(res.data)
			setFilterParams({
				...filterParams,
				block_id: blockId,
				gram_panchayat_id: -1
			})
		}, (err) => {
			console.log(err);
		}).finally(() => {
			setIsLoading(false);
		})
	}

	const renderApplications = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<span className="application-filter-text"> FILTERS </span>
							{
									loggedInUser.role_id == ROLES_MAP.field_officer &&
									<Link to="applications/operations">
										<Button color="primary" className="text-right">Add New Application</Button>
									</Link>
							}
						</CardHeader>
						<CardBody>
							<Row>
								<Col className="pr-1" md="3">
									<FormGroup>
										<label>Application name</label>
										<Input
											type="text"
											name="applicant_name"
											placeholder="Application Name"
											value={filterParams.applicant_name || ""}
											onChange={handleChange}
										/>
									</FormGroup>
								</Col>
								<Col className="pr-1" md="3">
									<FormGroup>
										<label>Mobile</label>
										<Input
											type="text"
											name="mobile_no"
											placeholder="Mobile"
											value={filterParams.mobile_no || ""}
											onChange={handleChange}
										/>
									</FormGroup>
								</Col>
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="categoryName">Category</Label>
										<Input
											type="select"
											name="category_id"
											value={filterParams.category_id}
											onChange={handleChange}
										>
											<option value={-1}>Select Category</option>
											{
												categories.map(category => (
													<option key={category.id} value={category.id}>{category.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="SchemeName">Scheme</Label>
										<Input
											type="select"
											name="scheme_id"
											value={filterParams.scheme_id}
											onChange={handleChange}
										>
											<option value={-1}>Select Scheme</option>
											{
												schemes.map(scheme => (
													<option key={scheme.id} value={scheme.id}>{scheme.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
							</Row>
							<Row>
									<Col className="pr-1" md="3">
										<FormGroup>
											<label>Date type</label>
											<Input
												type="select"
												name="date_type"
												id="report-date-type"
												value={selectedDateType.id}
												onChange={(e) => setSelectedDateTypeAndGetData(e)}
											>
												{
													REPORT_DATE_TYPES.map(type => (
														<option key={type.id} value={type.id}>{type.label}</option>
													))
												}
											</Input>
										</FormGroup>
									</Col>
									<Col className="pr-1" md="3">
										<FormGroup>
											<label>From Date</label>
											<DatePicker
												dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
												value= {filterParams.from_date} 
												onChange= {(value, f) => {
													setFilterParams({...filterParams, from_date: value})
													setSelectedDateType(REPORT_DATE_TYPES[3]); // Setting custom option
												}} />
										</FormGroup>
									</Col>
									<Col className="pr-1" md="3">
										<FormGroup>
											<label>To Date</label>
											<DatePicker
												dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
												value= {filterParams.to_date} 
												onChange= {(value, f) => {
													setFilterParams({...filterParams, to_date: value})
													setSelectedDateType(REPORT_DATE_TYPES[3]); // Setting custom option
												}} />
										</FormGroup>
									</Col>
									<Col className="pr-1" md="3">
										<FormGroup>
											<Label for="status">Status</Label>
											<Input
												type="select"
												name="status"
												value={filterParams.status}
												onChange={handleChange}
											>
												{
													APPLICATION_STATUS_LIST.map(status => (
														<option key={status.id} value={status.id}>{status.title}</option>
													))
												}
											</Input>
										</FormGroup>
									</Col>
								</Row>
							<Row>
							{
								(loggedInUser.role_id != ROLES_MAP.department_officer
										&& loggedInUser.role_id != ROLES_MAP.district_officer
										&& loggedInUser.role_id != ROLES_MAP.field_officer) &&
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="DepartmentName">Department</Label>
										<Input
											type="select"
											name="department_id"
											value={filterParams.department_id}
											onChange={handleChange}
										>
											<option value={-1}>Select Department</option>
											{
												departments.map(department => (
													<option key={department.id} value={department.id}>{department.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
							}
							{
								(loggedInUser.role_id != ROLES_MAP.district_officer
									&& loggedInUser.role_id != ROLES_MAP.field_officer
									&& loggedInUser.role_id != ROLES_MAP.dpm) &&
								(<>
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="DistrictName">District</Label>
										<Input
											type="select"
											name="district_id"
											value={filterParams.district_id}
											onChange={(e) => {
												getBlocks(e.target.value)
											}}
										>
											<option value={-1}>Select District</option>
											{
												districts.map(district => (
													<option key={district.id} value={district.id}>{district.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="blockName">Block</Label>
										<Input
											type="select"
											name="block_id"
											value={filterParams.block_id}
											onChange={(e) => {
												getGps(e.target.value)
											}}
										>
											<option value={-1}>Select Block</option>
											{
												blocks.map(block => (
													<option key={block.id} value={block.id}>{block.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="DistrictName">Gram Panchayat</Label>
										<Input
											type="select"
											name="gram_panchayat_id"
											value={filterParams.gram_panchayat_id}
											onChange={handleChange}
										>
											<option value={-1}>Select Gram Panchayat</option>
											{
												gramPanchayats.map(gp => (
													<option key={gp.id} value={gp.id}>{gp.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
								</>)
							}
							</Row>
							<Row>
								<Col className="pr-1" md="3">
									<FormGroup>
										<Label for="status">Date</Label>
										<DatePicker
											dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
											value= {filterParams.date} 
											onChange= {(value, f) => { setFilterParams({...filterParams, date: value})}} />
									</FormGroup>
								</Col>
								<Col className="pr-1" md="3">
									<div className="update ml-auto mt-3 mr-auto">
										<Button className="btn-round" onClick={() => searchApplication()} color="primary">
											Search
										</Button>
										<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
											Reset
										</Button>
									</div>
								</Col>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>		
			<Row className="applciation-table-row">
				<Col md="12">
					<Card className="applciation-table-card">
						<hr />
						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Reference id</th>
										<th>Applicant name</th>
										<th>Father's / Wife name</th>
										<th>Date applied on</th>
										<th>Date of birth</th>
										<th>Mobile</th>
										<th>Gram panchayat</th>
										<th>Block</th>
										<th>District</th>
										<th>Is reapplied</th>
										<th>Last Update</th>
										{
										(loggedInUser.role_id != ROLES_MAP.director
										 && loggedInUser.role_id != ROLES_MAP.field_officer) &&
											<th>Actions</th>
										}
									</tr>
								</thead>
								<tbody>
									{
										applications.map(application => (
											<tr key={application.id}>
												<td>{application.id}</td>
												<td>{application.reference_id || '--'}</td>
												<td>{application.applicant_name || '--'}</td>
												<td>{application.care_of_name || '--'}</td>
												<td>{application.created_at ? moment(application.created_at).format(DATE_FORMATS.DATE_ONLY_FORMAT) : '--'}</td>
												<td>{application.dob || '--'}</td>
												<td>{application.mobile_no || '--'}</td>
												<td>{application.gram_panchayat ? application.gram_panchayat.name : '--'}</td>
												<td>{application.block ? application.block.name : '--'}</td>
												<td>{application.district ? application.district.name : '--'}</td>
												<td>{application.is_replied ? 'Yes' : 'No'}</td>
												<td>{application.updated_at ? moment(application.updated_at).format(DATE_FORMATS.DATE_ONLY_FORMAT) : '--'}</td>
												{
													(loggedInUser.role_id != ROLES_MAP.director
													&& loggedInUser.role_id != ROLES_MAP.field_officer) &&
													<td className="action-icons">
														<Button className="application-action-btn" color="primary" onClick={() => viewApplication(application)}>View Application</Button>
													</td>
												}
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								applications.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreApplications()} color="primary">Load more</Button>
					</Col>
				</Row>
			}

			<Modal zIndex="9999" isOpen={isUpdateStatusModalOpen} toggle={() => setIsUpdateStatusModalOpen(!isUpdateStatusModalOpen)}>
				<ModalBody>
					<FormGroup>
						<Label for="status">Status</Label>
						<Input
							type="select"
							name="application_status"
							id="application_status"
							value={applicationUpdateData.status}
							onChange={(e) => setApplicationUpdateData({...applicationUpdateData, status: e.target.value})}
						>
							{
								APPLICATION_STATUS_LIST.map(status => (
									<option key={status.id} value={status.id}>{status.title}</option>
								))
							}
						</Input>
					</FormGroup>
					{
						applicationUpdateData.status == 'reject' &&
						<FormGroup>
							<Label for="status">Reject reason</Label>
							<Input
								type="textarea"
								name="reject_Reason"
								id="reject_Reason"
								value={applicationUpdateData.reject_reason}
								onChange={(e) => setApplicationUpdateData({...applicationUpdateData, reject_reason: e.target.value})}
							/>
						</FormGroup>
					}
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={() => updateApplicationData()}>Update</Button>{' '}
					<Button color="secondary" className="ml-2" onClick={() => setIsUpdateStatusModalOpen(false)}>Cancel</Button>
				</ModalFooter>
			</Modal>
			<SlidingPane
				className="some-custom-class"
				overlayClassName="some-custom-overlay-class"
				isOpen={isViewApplicationPaneOpen}
				title="Application Detail"
				from="right"
				width="960px"
				shouldCloseOnEsc={false}
				onRequestClose={() => {
					setIsViewApplicationPaneOpen(false)
				}}
				overlayClassName="z-index-9999"
			>
					<Table>
						<tr>
							<td className="view-application-td-title">Reference id:</td>
							<td className="view-application-td">{selectedApplication.reference_id || '--'}</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Applicant name:</td>
							<td className="view-application-td">{selectedApplication.applicant_name || '--'}</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Father's / Wife's name:</td>
							<td className="view-application-td">{selectedApplication.care_of_name}</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Date applied on:</td>
							<td className="view-application-td">
								{selectedApplication.created_at ? moment(selectedApplication.created_at).format(DATE_FORMATS.DATE_ONLY_FORMAT) : '--'}
							</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Date of birth:</td>
							<td className="view-application-td">{selectedApplication.dob}</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Mobile no:</td>
							<td className="view-application-td">{selectedApplication.mobile_no}</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Category:</td>
							<td className="view-application-td">
							{(selectedApplication.category_list && selectedApplication.category_list.length > 0)
									? selectedApplication.category_list.map((category, key) => (
										<span className={key != 0 && "view-application-scheme"} key={key}>{category.category.name}</span>
									)) : '--'}
							</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Scheme:</td>
							<td className="view-application-td">
								{(selectedApplication.scheme_list && selectedApplication.scheme_list.length > 0)
									? selectedApplication.scheme_list.map((scheme, key) => (
										<span className={key != 0 && "view-application-scheme"} key={key}>
											{scheme.scheme.name} {' '}
											<span> - {APPLICATION_STATUS_LIST.find(status => scheme.status == status.id).title}</span> {' '}
											<a className="view-application-link" onClick={() => updateApplicationStatus(scheme)}>Update status</a>
										</span>
									)) : '--'}
							</td>
						</tr>
						<tr>
							<td className="view-application-td-title">District:</td>
							<td className="view-application-td">
								{selectedApplication.district ? selectedApplication.district.name : '--'}
							</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Block:</td>
							<td className="view-application-td">
								{selectedApplication.block ? selectedApplication.block.name : '--'}
							</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Gram Panchayat:</td>
							<td className="view-application-td">
								{selectedApplication.gram_panchayat ? selectedApplication.gram_panchayat.name : '--'}
							</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Address:</td>
							<td className="view-application-td">{selectedApplication.address}</td>
						</tr>
						<tr>
							<td className="view-application-td-title">Is Reapplied:</td>
							<td className="view-application-td">{selectedApplication.is_replied ? 'Yes': 'No'}</td>
						</tr>
					</Table>
			</SlidingPane>

			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"> <Loader isLoading={isRequesting} /></div>
					: renderApplications()
			}
		</>
	);
}

export default Applications;
